import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-montserrat font-15" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Veja se atendemos o seu endereço! Informe seu CEP para verificarmos a disponibilidade de entrega ou retirada. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Procurar ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Usar minha localização atual ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Endereços encontrados ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Não encontramos nenhum endereço, altere os dados de pesquisa ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Se preferir podemos utilizar sua localização atual ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Desculpe, ainda não entregamos nesse local! ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Você pode ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "retirar", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" em nossa loja mais próxima de você ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "subtitulo-loja" }
const _hoisted_15 = { class: "km" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" km de distância ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Retirar Aqui")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Escolher outro Endereço")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "b4" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Confirme os dados para entrega ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Endereço para entrega ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "b4" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" km de distância até a loja de entrega ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Confirme o número para entrega ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Complemento do endereço ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Continuar ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "b4" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "font-montserrat"
}
const _hoisted_35 = {
  key: 1,
  class: "font-montserrat"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = { class: "subtitulo-loja" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_modal, {
      "backdrop-dismiss": false,
      "is-open": _ctx.isOpenLocation
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
                          size: "large",
                          color: "dark",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.chevronBack
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "9",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_input, {
                          class: "item_pesquisa",
                          placeholder: "Digite seu CEP aqui",
                          modelValue: _ctx.enderecoProcurar,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enderecoProcurar) = $event)),
                          onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoSearch())),
                          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.autoComplete()), ["enter"])),
                          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enderecoProcurar=$event.target.value)),
                          name: "endereco",
                          type: "endereco",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  color: "danger",
                                  size: "medium",
                                  slot: "end",
                                  icon: _ctx.search
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "2",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          class: "small-button",
                          size: "small",
                          shape: "jau",
                          color: "jauservelayoutalter"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, {
                  class: "ion-align-items-center",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getLocalicao()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          color: "dark",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "8",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "1",
                      class: "ion-no-padding"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          size: "small",
                          color: "dark",
                          fill: "clear"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.typing)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_spinner, { name: "circular" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.searchEnderecos.length > 0)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_list_header, null, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchEnderecos, (endereco, index) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            color: endereco == _ctx.selectedEnderecos?'light':'',
                            key: index,
                            onClick: ($event: any) => (_ctx.selectAdress(endereco))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", null, _toDisplayString(endereco.structured_formatting.main_text), 1),
                                  _createElementVNode("h3", null, _toDisplayString(endereco.structured_formatting.secondary_text), 1),
                                  _createElementVNode("p", null, _toDisplayString(endereco.description), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["color", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.sem_resultados)
                  ? (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_row, {
                              class: "ion-align-items-center",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getLocalicao()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_ion_modal, {
      "backdrop-dismiss": true,
      canDismiss: true,
      onDidDismiss: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isOpenSemEntrega=false)),
      "is-open": _ctx.isOpenSemEntrega,
      "initial-breakpoint": 0.85,
      breakpoints: [0.85, 0.85]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "b7",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "b3",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "retireaqui" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "b4",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13,
                    _createTextVNode(" Jaú Serve " + _toDisplayString(_ctx.currentEnderecos.loja) + " ", 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentEnderecos.subnome_loja) + " - " + _toDisplayString(_ctx.currentEnderecos.bairro_loja), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "b4b",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentEnderecos.end_loja), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "b5",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.currentEnderecos.distancia), 1),
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "ion-text-center",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goRetirada())),
                      size: "large",
                      shape: "jau",
                      color: "jauservelayoutalter"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "ion-text-center",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isOpenSemEntrega=false)),
                      size: "large",
                      shape: "jau",
                      color: "jauservelayoutciza6"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_23
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
    _createVNode(_component_ion_modal, {
      "backdrop-dismiss": true,
      canDismiss: true,
      onDidDismiss: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isOpenGetNumber=false)),
      "is-open": _ctx.isOpenGetNumber,
      "initial-breakpoint": 0.70,
      breakpoints: [0.7, 0.75]
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "b7",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_row, { class: "retireaqui" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }),
                    _hoisted_26,
                    _hoisted_27,
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.currentEnderecos.rua), 1)
                  ]),
                  _: 1
                }),
                (_ctx.currentEnderecos.distancia)
                  ? (_openBlock(), _createBlock(_component_ion_col, {
                      key: 0,
                      class: "b6 ion-text-end",
                      size: "12"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.currentEnderecos.distancia), 1),
                        _hoisted_29
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.currentEnderecos.numero,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentEnderecos.numero) = $event)),
                      onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.currentEnderecos.numero=$event.target.value)),
                      name: "numero",
                      class: "custom",
                      placeholder: "digite o numero",
                      type: "tel",
                      spellcheck: false,
                      autocapitalize: "off",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, { size: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_textarea, {
                      modelValue: _ctx.currentEnderecos.complemento,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentEnderecos.complemento) = $event)),
                      onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentEnderecos.complemento=$event.target.value)),
                      name: "numero",
                      class: "custom_area",
                      placeholder: "Casa, Numero apartamento etc",
                      type: "tel",
                      spellcheck: false,
                      autocapitalize: "off",
                      required: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "ion-text-center",
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isEnviando)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getLoja(''))),
                          size: "large",
                          color: "jauservelayoutalter",
                          shape: "jau",
                          expand: "block"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_button, {
                          key: 1,
                          color: "danger",
                          shape: "round"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_spinner, { name: "circular" })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_33
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
    _createVNode(_component_ion_row, {
      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showEndereco())),
      class: "ion-align-items-top top-header"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          style: _normalizeStyle({ marginTop: _ctx.safeTop + 'px' }),
          class: "ion-text-center",
          size: "12"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, {
                  class: "ion-text-end",
                  size: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      class: "top-header-icon",
                      icon: _ctx.locationOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, {
                  class: "ion-text-center",
                  size: "9"
                }, {
                  default: _withCtx(() => [
                    (_ctx.data.entrega)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createTextVNode(_toDisplayString(_ctx.data.endereco) + " ", 1),
                          _createVNode(_component_ion_icon, { icon: _ctx.chevronDown }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.data.entrega)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createTextVNode(" Jaú Serve " + _toDisplayString(_ctx.data.loja) + " ", 1),
                          _hoisted_36,
                          _hoisted_37,
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.data.subnome_loja) + " - " + _toDisplayString(_ctx.data.bairro_loja), 1),
                          _createVNode(_component_ion_icon, { icon: _ctx.chevronDown }, null, 8, ["icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    })
  ], 64))
}